import { Drawer, DrawerContent } from "@grupoboticario/flora-react";

import { DotGridIcon, CrossIcon } from "@grupoboticario/flora-react-icons";

import { useEffect, useState } from "react";
import {
  SideHeader,
  IconButton,
  SubItemMenu,
  LinkMenu,
  SideMenuList,
} from "./style";
import { useHistory } from "react-router-dom";
import FloraIcon from "../FloraIcon";
import { Logo } from "../Logo";
import { Skeleton } from "@mui/material";

export interface DrawerMenuProps {
  items: Array<DrawerItem>;
}
export interface DrawerItem {
  icon: String;
  title: String;
  path: String;
  external_link: String;
}

export function DrawerMenu(props: DrawerMenuProps) {
  const [isOpen, setOpen] = useState(false);
  const [menu, setMenu] = useState<Array<DrawerItem>>([]);

  useEffect(() => {
    setMenu(props.items);
  }, [isOpen, props]);

  const toggle = () => setOpen(!isOpen);
  let history = useHistory();

  function navigator(path: string) {
    window.localStorage.setItem("load-component-retried", "false");
    history.push(path);
    toggle();
  }

  return (
    <>
      <IconButton onClick={toggle}>
        <DotGridIcon size="36" color="$actionableAlt" />
      </IconButton>

      <Drawer open={isOpen} onOpenChange={toggle}>
        <DrawerContent side="left" css={{ maxWidth: 300 }}>
          <div>
            <SideHeader>
              <IconButton onClick={toggle} css={{ paddingTop: "10px" }}>
                <CrossIcon size="30" color="$actionableAlt" />
              </IconButton>
              <Logo />
            </SideHeader>
            <SideMenuList>
              <SubItemMenu key={"home"}>
                <LinkMenu onClick={() => navigator("/")}>
                  <FloraIcon iconText={"HouseIcon"} />
                  Home
                </LinkMenu>
              </SubItemMenu>
              {menu.length === 0 ? (
                <SubItemMenu key={"other"} style={{ paddingLeft: 40 }}>
                  <Skeleton variant="text" width={210} height={50} />
                  <br />
                  <Skeleton variant="text" width={210} height={50} />
                  <br />
                  <Skeleton variant="text" width={210} height={50} />
                  <br />
                  <Skeleton variant="text" width={210} height={50} />
                  <br />
                </SubItemMenu>
              ) : (
                ""
              )}
              {menu.map((e: any) => {
                if (!!e.external_link && !e.path) {
                  return (
                    <SubItemMenu key={e.path}>
                      <LinkMenu
                        onClick={() => window.open(e.external_link, "_blank")}
                      >
                        {e.icon ? <FloraIcon iconText={e.icon} /> : null}
                        {e.title}
                      </LinkMenu>
                    </SubItemMenu>
                  );
                } else if (!!e.path) {
                  return (
                    <SubItemMenu key={e.path}>
                      <LinkMenu onClick={() => navigator(e.path)}>
                        {e.icon ? <FloraIcon iconText={e.icon} /> : null}
                        {e.title}
                      </LinkMenu>
                    </SubItemMenu>
                  );
                }
              })}
            </SideMenuList>
          </div>
        </DrawerContent>
      </Drawer>
    </>
  );
}
